import ReservationHistories                 from "../../../../domain/reservation/history/ReservationHistories";
import { ApiClient }                        from "../../../configure/ApiClientConfig";
import { toReservationHistories }           from "../../../translator/reservation/history";
import { ReservationHistoriesResponseType } from "./ReservationHistoriesResponseType";

export const apiGetReservationCancelRequests = async (): Promise<ReservationHistories> => {
  try {
    const response = await ApiClient.get("/reservation/cancel/requests");
    const data: ReservationHistoriesResponseType = response.data;
    return toReservationHistories(data);
  } catch (e) {
    return new ReservationHistories();
  }
};
